var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.97,
    height: 41.712,
    viewBox: "0 0 44.97 41.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-wifi",
    transform: "translate(-35.378 -47.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16194",
    "data-name": "Path 16194",
    d: "M230.391,221.356c-2.055,2.057-3.986,3.986-5.91,5.924a1.771,1.771,0,0,1-1.505.614,1.6,1.6,0,0,1-1.421-1.1,1.618,1.618,0,0,1,.419-1.795q1.843-1.855,3.7-3.7c.734-.734,1.473-1.464,2.244-2.232-.145-.158-.267-.3-.4-.428q-2.764-2.768-5.528-5.535a1.661,1.661,0,0,1-.363-1.985,1.564,1.564,0,0,1,1.687-.912,2.431,2.431,0,0,1,1.13.6c1.83,1.782,3.625,3.6,5.429,5.408.136.136.246.3.385.466.206-.195.347-.323.482-.458,1.844-1.843,3.678-3.7,5.534-5.528a1.695,1.695,0,1,1,2.3,2.484q-2.635,2.635-5.271,5.267c-.186.185-.405.336-.609.5l-.072.227a2.346,2.346,0,0,1,.506.3c1.85,1.837,3.7,3.676,5.531,5.531a1.656,1.656,0,0,1-.477,2.762,1.568,1.568,0,0,1-1.957-.426q-2.732-2.724-5.453-5.459a4.292,4.292,0,0,1-.381-.527Z",
    transform: "translate(-159.362 -138.794)",
    fill: "#0098da",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16195",
    "data-name": "Path 16195",
    d: "M50.879,48.549c12.628.973,22.2,6.8,28.452,17.9a2.555,2.555,0,0,1,.33,1.291,1.574,1.574,0,0,1-1.281,1.43,1.68,1.68,0,0,1-1.836-.844c-.792-1.289-1.508-2.634-2.4-3.845A29.819,29.819,0,0,0,54.483,52.357a49.364,49.364,0,0,0-4.992-.425A1.689,1.689,0,0,1,47.9,49.606a1.57,1.57,0,0,1,1.5-1.053c.493-.016.986,0,1.48,0Z",
    transform: "translate(-10.222)",
    fill: "#0098da",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16196",
    "data-name": "Path 16196",
    d: "M69.437,131.7a1.884,1.884,0,0,1-1.306,1.651,1.632,1.632,0,0,1-1.877-.722,20.3,20.3,0,0,0-5.706-5.576,20.062,20.062,0,0,0-11.03-3.256,1.678,1.678,0,0,1-1.635-2.323,1.592,1.592,0,0,1,1.654-1.058A22.993,22.993,0,0,1,59.6,122.675a23.363,23.363,0,0,1,9.337,7.958,6.882,6.882,0,0,1,.5,1.072Z",
    transform: "translate(-10.207 -61.725)",
    fill: "#0098da",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16197",
    "data-name": "Path 16197",
    d: "M49.945,192.05A13.611,13.611,0,0,1,62.823,203.3a18.356,18.356,0,0,1,.2,2.153,1.679,1.679,0,0,1-1.655,1.86,1.717,1.717,0,0,1-1.711-1.822,9.952,9.952,0,0,0-5.709-9.016,9.688,9.688,0,0,0-4.44-1.007,1.683,1.683,0,0,1-.6-3.26,5.911,5.911,0,0,1,1.032-.161Z",
    transform: "translate(-10.248 -123.241)",
    fill: "#0098da",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16198",
    "data-name": "Path 16198",
    d: "M42.641,267.646a3.381,3.381,0,1,1-3.369-3.406,3.39,3.39,0,0,1,3.369,3.406Z",
    transform: "translate(0 -185.237)",
    fill: "#0098da",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWify);
export default __webpack_public_path__ + "static/media/wify.50b8c801c119995f17c254d871d4eabb.svg";
export { ForwardRef as ReactComponent };